import { LogoMark } from "@/components/Logo";

export const Footer = () => (
  <footer className="bg-ink text-bone" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 md:px-10">
      <div className="grid gap-12 md:grid-cols-[2fr_1fr_1fr]">
        <div>
          <p className="font-display text-5xl leading-[0.95] md:text-7xl">Live with<br /><em className="text-clay">less, better.</em></p>
        </div>
        <div className="space-y-2 text-sm text-bone/70">
          <p className="mb-4 text-[11px] uppercase tracking-[0.2em] text-bone">Visit</p>
          <p>[Studio address]</p>
          <p>[City, State]</p>
        </div>
        <div className="space-y-2 text-sm text-bone/70">
          <p className="mb-4 text-[11px] uppercase tracking-[0.2em] text-bone">Talk to us</p>
          <p>[+91 phone number]</p>
          <p>[hello@yourbrand.com]</p>
        </div>
      </div>
      <div className="mt-20 flex items-end justify-between border-t border-bone/15 pt-8">
        <div className="flex items-center gap-3">
          <LogoMark className="h-9 w-9" />
          <span className="font-display text-[clamp(3rem,12vw,10rem)] leading-[0.8] tracking-tight">Borcelle</span>
        </div>
        <p className="hidden text-xs text-bone/60 md:block">© {new Date().getFullYear()} Borcelle. Collection 2027.</p>
      </div>
    </div>
  </footer>
);
